module.exports = __webpack_public_path__ + "static/media/fa-solid-900.b15db15f.woff2";